import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { Image } from 'react-bootstrap';

export default function ToolTip({ icon, toolTipContent, imageStyle = {}, placement = 'right' }) {
  return (
    <Tooltip placement={placement} trigger={['click', 'hover']} overlay={toolTipContent}>
      <Image src={icon} style={imageStyle} className="ms-1" />
    </Tooltip>
  );
}
